import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw.js";
import {PaymentMethodSelectInput} from "./PaymentMethodSelectInput.jsx";


// TODO @cleanup this is crap
@autoredraw(PaymentMethodStore)
export class ChooseCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            paymentMethod: null,
            onAddCard: NOOP_FUNCTION,
            onChange: NOOP_FUNCTION,
            testId: "chooseCard",
            entry: null,
        };
    }

    constructor(...args) {
        super(...args);

        this.selectedCard = this.options.card;
    }

    isValid() {
        return true;
    }

    getActive() {
        return this.selectedCard;
    }

    // TODO @input why is there a callback here?????
    getPaymentMethodId(scope, callback) {
        callback(this.selectedCard.id);
    }

    handleCardSelection(card) {
        this.selectedCard = card;
        this.redraw();
        this.options.onChange(card);
    }

    render() {
        const {onAddCard, entry} = this.options; // TODO @cleanup entry should be rename to something else/removed

        return [
            <PaymentMethodSelectInput
                initialValue={this.selectedCard}
                onChange={(card) => this.handleCardSelection(card)}
                onAddCard={onAddCard}
                showHeader={true}
                recurringPayment={entry}
                showDescription={true}
            />,
        ]
    }
}
